<div id="panel-right" class="d-block bg-very-light-gray border-l" style="height: 100vh">
  <div class="d-block bg-white border-b">
    <div class="grid-x bg-white">
      <div class="cell auto padding-l-l"
           style="display: flex; align-items: center;">
        <h4 style="font-weight:500;font-size:1.5rem;line-height:24px;color: #37404E;">
          {{'event.title' | translate}}
        </h4>
      </div>
      <div class="cell shrink">
        <button aria-label="Close modal"
                class="button hollow link default"
                mat-dialog-close="">
          <i class="margin-all fal fa-times fa-2x"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="hds-panel bg-sidebar">
    <div class="hds-panel-body padding-reset bg-sidebar">
      <div class="d-block margin-h-s margin-b-l bg-sidebar">

        <app-agenda></app-agenda>

      </div>
    </div>
  </div>
</div>

